import { EPHARMA_FEATURES } from './epharma';
import { TEMFARMA_FEATURES } from './temfarma';
import { VIDALINK_FEATURES } from './vidalink';

export const DISCOUNT_MEDICINES_FEATURES = [
  ...EPHARMA_FEATURES,
  ...VIDALINK_FEATURES,
  ...TEMFARMA_FEATURES,
];
